module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gNpNF"))).then(() => parcelRequire('d0iPb'));